var map = {
	"./device.svg": "2c87",
	"./file.svg": "b8b2",
	"./health.svg": "1010",
	"./home.svg": "6bbe",
	"./menu_right.svg": "c7eb",
	"./person.svg": "a450",
	"./sys.svg": "7213",
	"./train.svg": "1f54"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";